import { get } from 'lodash'
import { required, maxLength } from 'utils/validation'

const validate = values => {
  let errors = {}

  errors = {
    organizationName: required(get(values, 'organizationName')),
    organizationType: {
      value: required(get(values, 'organizationType.value'))
    },
    isAlreadyRunningAward: required(get(values, 'isAlreadyRunningAward')),
    line1: required(get(values, 'line1')),
    city: required(get(values, 'city')),
    zipCode: required(get(values, 'zipCode')),
    stateOrProvinceOrRegion:
      required(get(values, 'stateOrProvinceOrRegion')) ||
      maxLength(70)(get(values, 'stateOrProvinceOrRegion')),
    addressCountryId: required(get(values, 'addressCountryId'))
  }

  return errors
}

export default validate
